import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { find, isNil, pull } from 'lodash';
import { LampsSelectedService } from '../../../services/lamps-selected.service';
import { MapStoreService } from '../../../services/map-store.service';
import { MapService } from '../../../services/map.service';

@Component({
  selector: 'app-expansion-conversion-bar',
  templateUrl: './expansion-conversion-bar.component.html',
  styleUrls: ['./expansion-conversion-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ExpansionConversionBarComponent {
  @Input() expanded = false;
  @Input() lampGroup: any;
  @Input() isSameManufacturer: boolean = false;
  @Input() recommendationType: string = '';
  @Input() isManual: boolean = false;
  @Input() lampGroupNewModelName: string = '';
  @Output() closed = new EventEmitter();
  @Output() opened = new EventEmitter();
  @Output() modelRemoved = new EventEmitter();
  @Output() showProductCatalogByModel = new EventEmitter();
  @Output() showProductDetailByModel = new EventEmitter();
  @Output() isHighlightChange = new EventEmitter();

  lamps: any[] = [];
  lampId: any;

  lampExpanded = false;

  constructor(private lampsSelectedservice: LampsSelectedService, private mapService: MapService, private mapStoreService: MapStoreService) {}

  toggle() {
    this.expanded = !this.expanded;

    if (this.expanded) {
      this.opened.emit();
    } else {
      this.closed.emit();
    }
  }

  toggleLampExpand() {
    this.lampExpanded = !this.lampExpanded;
  }

  remove(array: [], value: any) {
    pull(array, value);
  }

  removeLampModel() {
    this.expanded = false;
    this.modelRemoved.emit();
  }

  removeLamp(lamp: any) {
    this.lampsSelectedservice.remove(lamp);
    pull(this.lampGroup.lamps, lamp);
  }

  isAllRecommended(lamps: any[]) {
    let found = false;
    lamps.forEach((element) => {
      if (isNil(element.isRecommended) || !element.isRecommended) {
        found = true;
      }
    });
    return !found;
  }

  showAlternatives(lamps: any[]) {
    this.lamps = lamps;
    this.showProductCatalogByModel.emit({
      lamps: this.lamps,
      lampId: lamps[0].assetId,
    });
  }

  toggleHighlight() {
    this.lampGroup.isHighlighted = !this.lampGroup.isHighlighted;
    this.isHighlightChange.emit(this.lampGroup.isHighlighted);
    this.setLampHighlight(this.lampGroup.isHighlighted);
  }

  setLampHighlight(value: any) {
    this.lampGroup.lamps.forEach((element: any) => {
      const selectedLamp = find(this.mapStoreService.lampMarkers, (marker) => marker.options.data.equipment === element.equipment);
      if (!isNil(selectedLamp)) {
        if (selectedLamp.options.data.hasMultipleLamps === true) {
          selectedLamp.options.data.lamps.forEach((lamp: any) => {
            if (lamp.assetId === element.assetId) {
              lamp.isHighlighted = value;
            }
          });

          const highlightedLamps = selectedLamp.options.data.lamps.find((lamp: any) => lamp.isHighlighted === true);
          let highlight = false;
          if (highlightedLamps) {
            highlight = true;
          }
          selectedLamp.options.isHighlighted = highlight;
          this.mapService.setClassLamp(selectedLamp, {
            isSelected: true,
            isHighlighted: highlight,
          });
        } else {
          selectedLamp.options.isHighlighted = value;
          this.mapService.setClassLamp(selectedLamp, {
            isSelected: true,
            isHighlighted: value,
          });
        }
      }
    });
  }

  showProductDetail() {
    this.showProductDetailByModel.emit({
      lamps: this.lampGroup.lamps,
      lampId: this.lampGroup.lamps[0].assetId,
    });
  }

  trackByFn(_: number, item: any) {
    return item.assetId;
  }
}
